"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _Icon = _interopRequireDefault(require("./Icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ClosableInput = function ClosableInput(_ref) {
  var id = _ref.id,
      value = _ref.value,
      placeholder = _ref.placeholder,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$valueLink = _ref.valueLink,
      valueLink = _ref$valueLink === void 0 ? null : _ref$valueLink,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      _ref$onClear = _ref.onClear,
      onClear = _ref$onClear === void 0 ? function () {} : _ref$onClear;
  var Clickable = !disabled && valueLink ? function (_ref2) {
    var style = _ref2.style,
        children = _ref2.children;
    return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
      to: valueLink,
      style: style
    }, children);
  } : function (_ref3) {
    var style = _ref3.style,
        children = _ref3.children;
    return /*#__PURE__*/_react["default"].createElement("div", {
      onClick: disabled ? function () {} : onClick,
      style: style
    }, children);
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: id,
    style: _objectSpread({
      cursor: 'pointer',
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      height: 38,
      backgroundColor: 'white',
      borderRadius: '5px',
      paddingLeft: 0,
      paddingRight: 0,
      marginBottom: 14,
      color: 'rgba(0,0,0,.87)'
    }, disabled ? {
      opacity: 0.6,
      cursor: 'not-allowed'
    } : {})
  }, /*#__PURE__*/_react["default"].createElement(Clickable, {
    style: {
      display: 'flex',
      alignItems: 'center',
      flex: '1',
      height: '100%',
      paddingLeft: 15,
      color: value ? 'rgba(0,0,0,.87)' : 'gray'
    }
  }, value || placeholder), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      height: '100%',
      paddingLeft: 20,
      paddingRight: 7,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      fontSize: '0.85em',
      cursor: 'pointer'
    },
    onClick: value ? onClear : function () {}
  }, value && /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    name: "close",
    color: "grey"
  })));
};

var _default = ClosableInput;
exports["default"] = _default;